// export DsfDepartmentMigration from "./departmentMigration.vue";

export const DsfDepartmentMigration =dsf.defineAsyncComponent('DsfDepartmentMigration',()=>import(/*webpackChunkName:"platform_other"*/"./departmentMigration.vue"))